import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import { useHistory, useLocation } from "react-router-dom";
import { ValOnlyNumber } from "../../../Validators/ValOnlyNumber";
import { ValTextAndNumber } from "../../../Validators/ValTextAndNumber";
import { InputAdornment, TextField } from "@mui/material";
import { GetDocumentpo } from "../../../Helpers/GetDocumento";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BusinessIcon from "@mui/icons-material/Business";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { TextFieldCliente } from "../FacturarCreditoCerrados/TextFieldCliente";
import { ValidarDatosFactura } from "../FacturarCreditoCerrados/ValidaDatosFactura";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import AddCircleIcon from "@mui/icons-material/AddCircle";


export const RefacturacionCreditoScreen = () => {
    const history = useHistory();
    const { state } = useLocation();

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [datos_pedido, setDatos_pedido] = useState({});
    const [financiamiento, setFinanciamiento] = useState([]);
    const [unidades, setUnidades] = useState([]);
    const [datos_facturacion, setDatosFacturacion] = useState({
        comentarios: "",
        comentarioscredito: "",
        estado: "",
        tiempoestimado: "",
        tiempotranscurrido: "",
        factura: false,
        nota_abono: false,
        idequip: "",
        idsucursal: "",
        serie_fiscal: "",
        folio_fiscal: "",
        documento: "",
    });
    const [sucursales_cliente, setSucursales_cliente] = useState([]);
    const [selected, setselected] = useState(null);
    const [factura, setFactura] = useState({
        documento: "",
        extension: "",
    });
    const [notaabono, setNotaAbono] = useState({
        documento: "",
        extension: "",
    });
    const [documentosequipo, setDocumentosEQUIP] = useState([]);
    const onDatosFacturacion = (prop, value, sbool, smensaje) => {
        setDatosFacturacion({
            ...datos_facturacion,
            [prop]: value,
        });
    };

  




    const onImprimirArchivo = (iddocumento) => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(
                `SolicitudCreditoDocumentacion/ObtenerFactura?folio=${state.folio
                }&registro=${selected.registro}&iddocumento=${Number(iddocumento)}`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = result.comentarios;
                const downloadLink = document.createElement("a");
                const fileName = `${result.documento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    };
    const onGuardar = () => {
        var data = datos_facturacion;
        const validate = ValidarDatosFactura(
            data,
            factura,
            notaabono,
            state.folio,
            datos_pedido.financiera,
            datos_facturacion.factura,
            datos_facturacion.nota_abono,
            selected.registro
        );

        var mensaje = "";
        var valido = true;
        documentosequipo.forEach((element) => {
            if (
                element.documento === undefined ||
                element.documento === null ||
                element.documento === ""
            ) {
                mensaje =
                    mensaje +
                    "Pendiente de relacionar el numero de documento en equip para el registro con importe de <bold>" +
                    FormatMoney(element.totalpagar) +
                    "</bold><br/><br/>";
                valido = false;
            }
        });
        if (valido === false) {
            Swal.fire("FACTURACION", mensaje, "error");
            return;
        }

        if (validate.isValid === false) {
            Swal.fire("FACTURACION", validate.mensaje, "error");
            return;
        }

        validate.post.documentos = documentosequipo;
        setLoader({ ...loader, mostrar: true });
        request
            .post("RefacturacionCredito", validate.post)
            .then(async (result) => {
                setLoader({ ...loader, mostrar: false });
                // commentNotification(result.mdlSolicitud);
                setDocumentosEQUIP([]);
                setDatosFacturacion([]);
                setSucursales_cliente([]);
                setselected(null);
                await Swal.fire(
                    "FACTURACION",
                    "Factura Registrada con exito",
                    "success"
                );
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("FACTURACION", JSON.stringify(error), "error");
            });
    };
    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`FacturarEquipo/informacion_pedido?folio=${state.folio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setDatos_pedido(result.datos_pedido);
                setFinanciamiento(result.financiamiento);
                setUnidades(result.unidades);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("FACTURACION", JSON.stringify(error), "error");
            });
    }, []);

    const onBuscarFactura = (item) => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(
                `FacturarEquipo/informacion_pedido_unidad?folio=${state.folio
                }&registro=${Number(item.registro)}`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setDatosFacturacion(result.datos_pedido);
                setSucursales_cliente(result.sucursales);
                setselected(item);
                setDocumentosEQUIP(result.documentos);
                console.log(datos_facturacion.serie_fiscal);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("FACTURACION", JSON.stringify(error), "error");
            });
    };
    const [updatedocumento, setupdatedocumento] = useState(null);

    useEffect(() => {
        if (updatedocumento !== null) {
            const registros = documentosequipo.length;
            setDocumentosEQUIP(
                documentosequipo.filter((aa, index) => index !== registros - 1)
            );
        }
    }, [updatedocumento]);

    const updateDocumentoFinanciamiento = (index, value) => {
        var newvalue = documentosequipo;
        newvalue[index].docto_financiamiento = value;
        newvalue = [...newvalue, { orden: 0, documento: "" }];
        setDocumentosEQUIP(newvalue);
        setupdatedocumento(!(updatedocumento === null ? true : updatedocumento));
    };

    const updateDocumento = (index, value) => {
        var newvalue = documentosequipo;
        newvalue[index].documento = value;
        newvalue = [...newvalue, { orden: 0, documento: "" }];
        setDocumentosEQUIP(newvalue);
        setupdatedocumento(!(updatedocumento === null ? true : updatedocumento));
    };

    const onEliminarDocumento = (orden, index) => {
        if (orden !== 0) {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `FacturarEquipo/EliminarRegistro?folio=${state.folio}&orden=${Number(
                        orden
                    )}&registro=${Number(selected.registro)}`
                )
                .then(() => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("Facturación de Equipo", "Registro eliminado", "success");
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("FACTURACION", JSON.stringify(error), "error");
                });
        }
        setDocumentosEQUIP(
            documentosequipo.filter((e, position) => position !== index)
        );
    };

    return (
        <PlantillaScreen
            titulo={`REFACTURAR CREDITO DE ${state.cliente.toUpperCase()}`}
            className={"listado-tasa-intereses-main-screen"}
            className_main={1}
        >
            <div className="solicitud-credito-a-refacturar">
                <LoaderScreen loader={loader} />
                <div className="solicitud-credito-datos-pedido">
                    <TextField
                        label="Razón Social"
                        value={datos_pedido.razonsocial}
                        size="small"
                        color="success"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <BusinessIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <TextField
                        label="RFC"
                        value={datos_pedido.rfc}
                        size="small"
                        color="success"
                        sx={{ mt: 2 }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <BusinessIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <TextField
                        label="Método de Pago"
                        value={datos_pedido.metodopago}
                        size="small"
                        color="success"
                        sx={{ mt: 2 }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <ReceiptIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <TextField
                        label="Forma de Pago"
                        value={datos_pedido.formapago}
                        size="small"
                        color="success"
                        sx={{ mt: 2 }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <ReceiptIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <TextField
                        label="Uso de CFDI"
                        value={datos_pedido.usocfdi}
                        size="small"
                        color="success"
                        sx={{ mt: 2 }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <ReceiptIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <TextField
                        label="Tipo de Relación"
                        value={datos_pedido.tiporel}
                        size="small"
                        color="success"
                        sx={{ mt: 2 }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <ReceiptIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <TextField
                        label="Anticipos"
                        value={datos_pedido.anticipos}
                        size="small"
                        color="success"
                        sx={{ mt: 2 }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <ReceiptIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <TextField
                        label="Folios de Anticipos"
                        value={datos_pedido.foliosanticipos}
                        size="small"
                        color="success"
                        sx={{ mt: 2 }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <ReceiptIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>
                <div className="solicitud-credito-info-refacturar scroll-4">
                    <div className="header">
                        Datos de Factura ({datos_pedido.financiera})
                    </div>

                    {/* Tabla para representar los equipos solicitados*/}
                    <div className="container-table-unidades">
                        <table cellPadding={0} cellSpacing={0}>
                            <thead>
                                <tr>
                                    <th>Línea</th>
                                    <th>Modelo</th>
                                    <th>Importe</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {unidades.map((item) => (
                                    <tr>
                                        <td>{item.linea}</td>
                                        <td>{item.modelo}</td>
                                        <td>{FormatMoney(item.importe)}</td>
                                        <td>
                                            <ReceiptLongIcon onClick={() => onBuscarFactura(item)} />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Tabla de los detalles del financiamiento*/}
                    <div className="container-table-financiamiento">
                        <table cellPadding={0} cellSpacing={0}>
                            <thead>
                                <tr>
                                    <th>Docto</th>
                                    <th>Vencimiento</th>
                                    <th>Importe</th>
                                    <th>Interes</th>
                                    <th>Total Pagar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {financiamiento.map((item) => (
                                    <tr>
                                        <td>{item.docto}</td>
                                        <td>{item.vencimiento}</td>
                                        <td>{FormatMoney(item.importefinanciar)}</td>
                                        <td>{FormatMoney(item.interes)}</td>
                                        <td>{FormatMoney(item.totalpagar)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/*FACTURAS */}
                    {selected !== undefined && selected !== null && (
                        <div className="solicitud-credito-refactura">
                            <div className="solicitud-credito-refactura-header">
                                {`${selected.modelo} (${FormatMoney(selected.importe)})`}
                            </div>
                            <TextField
                                fullWidth
                                size="small"
                                label="Serie Fiscal"
                                className="col1"
                                type="text"
                                onChange={({ target }) => {
                                    ValTextAndNumber(
                                        "serie_fiscal",
                                        target.value,
                                        onDatosFacturacion,
                                        true,
                                        10
                                    );
                                }}
                                value={datos_facturacion.serie_fiscal}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <ReceiptIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <TextField
                                fullWidth
                                size="small"
                                label="Folio Fiscal"
                                className="col2"
                                type="text"
                                onChange={({ target }) => {
                                    ValTextAndNumber(
                                        "folio_fiscal",
                                        target.value,
                                        onDatosFacturacion,
                                        true,
                                        10
                                    );
                                }}
                                value={datos_facturacion.folio_fiscal}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <ReceiptIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <TextField
                                fullWidth
                                size="small"
                                label="Documento EQUIP"
                                className="cel3"
                                type="text"
                                onChange={({ target }) => {
                                    ValOnlyNumber(
                                        "documento",
                                        target.value,
                                        onDatosFacturacion,
                                        true,
                                        10
                                    );
                                }}
                                value={datos_facturacion.documento}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <ReceiptIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <TextFieldCliente
                                array={sucursales_cliente}
                                onDatosFacturacion={onDatosFacturacion}
                                idequip={datos_facturacion.idequip}
                            />
                            <TextField
                                fullWidth
                                size="small"
                                label="Sucursal"
                                className="col5"
                                type="text"
                                value={datos_facturacion.sucursal}
                                disabled={true}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <BusinessIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <div className="col8">
                                <div className="label-refacturacion">Cargar Factura</div>
                                <TextField
                                    // label="Cargar Factura"
                                    fullWidth
                                    size="small"
                                    type="file"
                                    onChange={({ target }) => GetDocumentpo(target, setFactura)}
                                />
                                {datos_facturacion.factura === true && (
                                    <CheckCircleIcon
                                        className="has_document"
                                        onClick={() =>
                                            onImprimirArchivo(
                                                datos_pedido.financiera === "JDF" ? 71 : 28
                                            )
                                        }
                                    />
                                )}
                            </div>
                            {datos_pedido.financiera === "JDF" && (
                                <div className="col9">
                                    <div className="label-refacturacion">CARGAR NOTA DE ABONO</div>
                                    <TextField
                                        // label="Cargar Nota de abono"
                                        fullWidth
                                        size="small"
                                        type="file"
                                        onChange={({ target }) =>
                                            GetDocumentpo(target, setNotaAbono)
                                        }
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end"></InputAdornment>
                                            ),
                                        }}
                                    />
                                    {datos_facturacion.nota_abono === true && (
                                        <CheckCircleIcon
                                            className="has_document"
                                            onClick={() => onImprimirArchivo(78)}
                                        />
                                    )}
                                </div>
                            )}
                            <table
                                className="solicitud-credito-detalle-factura"
                                cellPadding={0}
                                cellSpacing={0}
                            >
                                <thead>
                                    <tr>
                                        <th>Documentos Equip</th>
                                        <th>Documentos Financiamiento</th>
                                        <th>
                                            <AddCircleIcon
                                                onClick={() =>
                                                    setDocumentosEQUIP([
                                                        ...documentosequipo,
                                                        { orden: 0, documento: "", docto_financiamiento: "" },
                                                    ])
                                                }
                                            ></AddCircleIcon>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {documentosequipo.map((item, index) => (
                                        <tr>
                                            <td colSpan={1}>
                                                <DeleteForeverIcon
                                                    onClick={() => onEliminarDocumento(item.orden, index)}
                                                ></DeleteForeverIcon>

                                                <input
                                                    id={`ìnput-${index}`}
                                                    value={item.documento}
                                                    onChange={({ target }) =>
                                                        updateDocumento(index, target.value)
                                                    }
                                                ></input>
                                            </td>
                                            <td colSpan={2}>
                                                <input
                                                    id={`ìnput-${index}`}
                                                    value={item.docto_financiamiento}
                                                    onChange={({ target }) =>
                                                        updateDocumentoFinanciamiento(index, target.value)
                                                    }
                                                ></input>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
            <div className="solicitud-credito-footer">
                <div
                    className="solicitud-credito-footer-regresar"
                    onClick={() => {
                        history.push(
                            "/Credito/ListadoRefacturacion"
                        );
                    }}
                >
                    <ArrowBackIcon />
                    Regresar
                </div>
                <div
                    className="solicitud-credito-footer-guardar"
                    onClick={() => {
                        onGuardar();
                    }}
                >
                    <CheckCircleIcon />
                    <div>Registrar</div>
                </div>
            </div>
        </PlantillaScreen>
    );
};
